import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import DeviceTableDto from 'app/admin/device/dto/DeviceTableDto';
import EventSeverity from './EventSeverity';

export default class EventEditDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {Date} */
		this.timestamp = null;
		/** @type {string} */
		this.text = null;
		/** @type {string} */
		this.severity = null;
		/** @type {number} */
		this.device = null;
		/** @type {number} */
		this.code = null;
		/** @type {number} */
		this.project = null;
	}

	/**
	 * @typedef {Object} _EventEditDtoProps
	 * @property {Date} timestamp
	 * @property {string} text
	 * @property {string} severity
	 * @property {number} device
	 * @property {number} code
	 * @property {number} project
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _EventEditDtoProps} EventEditDtoProps
	 */
	/**
	 *
	 * @param {EventEditDtoProps} props
	 * @returns {EventEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.timestamp = props.timestamp !== null ? new Date(props.timestamp) : null;
		this.text = props.text;
		this.severity = props.severity;
		this.device = props.device;
		this.code = props.code;
		this.project = props.project;
		return this;
	}
}
